<button
  type="button"
  class="selector-pill"
  [disabled]="disabled()"
  [attr.aria-expanded]="isOpen()"
  [attr.aria-label]="'virusMonitor.protectionTypes.summaryLabel' | translate"
  (click)="toggleOpen()"
>
  <span class="selector-pill__lead">{{ 'virusMonitor.protectionTypes.summaryLabel' | translate }}</span>
  @if (selectedIcons().length) {
    <span class="selector-pill__icons">
      @for (protectionType of selectedIcons(); track protectionType.type) {
        <span
          class="selector-pill__icon"
          [class.selector-pill__icon--warn]="hasWarning(protectionType.type)"
          [attr.title]="
            hasWarning(protectionType.type) ? ('virusMonitor.protectionTypes.expiredWarning' | translate) : null
          "
        >
          <img alt="" [src]="protectionType.iconPath" />
        </span>
      }
    </span>
  } @else {
    <span class="selector-pill__empty">{{ 'virusMonitor.protectionTypes.noAvailable' | translate }}</span>
  }
  <span class="selector-pill__arrow">{{ isOpen() ? '▴' : '▾' }}</span>
</button>

@if (isOpen()) {
  <dialog class="selector-popover" open>
    <div class="selector-popover__title">{{ 'virusMonitor.protectionTypes.title' | translate }}</div>
    <div class="selector-popover__description">{{ 'virusMonitor.protectionTypes.helpText' | translate }}</div>

    <div class="selector-options">
      @for (protectionType of protectionTypes; track protectionType.type) {
        <button
          type="button"
          class="selector-option"
          [class.selector-option--disabled]="!isAvailable(protectionType.type)"
          [class.selector-option--selected]="isSelected(protectionType.type)"
          [disabled]="!isAvailable(protectionType.type)"
          (click)="toggleProtectionType(protectionType.type)"
        >
          <span
            class="selector-option__checkbox"
            [ngClass]="{ 'selector-option__checkbox--selected': isSelected(protectionType.type) }"
          ></span>
          <span
            class="selector-option__icon"
            [class.selector-option__icon--warn]="hasWarning(protectionType.type) && isSelected(protectionType.type)"
            [attr.title]="
              hasWarning(protectionType.type) && isSelected(protectionType.type)
                ? ('virusMonitor.protectionTypes.expiredWarning' | translate)
                : null
            "
          >
            <img alt="" [src]="protectionType.iconPath" />
          </span>
          <span class="selector-option__content">
            <span class="selector-option__heading">
              <span class="selector-option__label">{{ protectionType.translationKey | translate }}</span>
              <span class="selector-option__status" [ngClass]="statusClass(protectionType.type)">
                {{ statusLabelKey(protectionType.type) | translate }}
              </span>
            </span>
            <span
              class="selector-option__hint"
              [class.selector-option__hint--warning]="detailFor(protectionType.type).status === 'expired'"
            >
              {{ descriptionKey(protectionType.type) | translate: descriptionParams(protectionType.type) }}
            </span>
          </span>
        </button>
      }
    </div>

    @if (availableCount() > 0 && draftSelection().length === 0) {
      <div class="selector-popover__validation">
        {{ 'errors.virusMonitor.invalidProtectionTypeSelection' | translate }}
      </div>
    }

    <div class="selector-popover__actions">
      <button type="button" mat-button (click)="close()">
        {{ 'virusMonitor.protectionTypes.cancel' | translate }}
      </button>
      <button type="button" mat-flat-button color="accent" [disabled]="disabled() || !canSave()" (click)="save()">
        {{ 'virusMonitor.protectionTypes.save' | translate }}
      </button>
    </div>
  </dialog>
}
